import { render, staticRenderFns } from "./SettingsInvoice.vue?vue&type=template&id=48be6346&scoped=true"
import script from "./SettingsInvoice.vue?vue&type=script&lang=js"
export * from "./SettingsInvoice.vue?vue&type=script&lang=js"
import style0 from "./SettingsInvoice.vue?vue&type=style&index=0&id=48be6346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be6346",
  null
  
)

export default component.exports